var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { prepareDiagramDataHierarchical } from '../basics/Statistics';
import { DiagramBase } from '../basics/DiagramBase';
import { setOrDef } from '../Helpers';
var Tree = /** @class */ (function (_super) {
    __extends(Tree, _super);
    function Tree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.calcData = function (props) {
            prepareDiagramDataHierarchical(props.diagram).then(function (data) {
                _this.setState({ data: data.data });
                if (_this.props.onFieldsLoaded)
                    _this.props.onFieldsLoaded(data.fields);
            });
        };
        _this.getOption = function () {
            var d = _this.props.diagram;
            if (!_this.state.data)
                return undefined;
            var option = {
                backgroundColor: d.backgroundColor,
                tooltip: {},
                toolbox: {
                    bottom: -5,
                    right: 0,
                    showTitle: false,
                    orient: 'horizontal',
                    feature: {
                        saveAsImage: {
                            show: d.legend && d.legend.showDownload ? true : false,
                            type: 'png'
                        }
                    }
                },
                series: {
                    type: 'tree',
                    initialTreeDepth: setOrDef(d, function (x) { return x.initialDepth; }, 3),
                    left: setOrDef(d.padding, function (x) { return x.left; }, 5) + "%",
                    right: setOrDef(d.padding, function (x) { return x.left; }, 10) + "%",
                    top: setOrDef(d.padding, function (x) { return x.left; }, 10) + "%",
                    bottom: setOrDef(d.padding, function (x) { return x.left; }, 5) + "%",
                    layout: setOrDef(d, function (x) { return x.treeLayout; }, "orthogonal"),
                    orient: setOrDef(d, function (x) { return x.orientation; }, "LR").toLocaleUpperCase(),
                    data: [{ name: "all", children: _this.state.data }],
                    symbol: setOrDef(d, function (x) { return x.symbolType; }, 'diamond'),
                    symbolSize: setOrDef(d, function (x) { return x.symbolSize; }, 15),
                    roam: setOrDef(d, function (x) { return x.roam; }, false),
                    label: d.label && d.label.show ? {
                        position: 'top',
                        distance: setOrDef(d, function (x) { return x.labelDistance; }, 10),
                        fontSize: setOrDef(d, function (x) { return x.fontSize; }, 12),
                        color: setOrDef(d, function (x) { return x.fontColor; }, "#000"),
                        rotate: setOrDef(d, function (x) { return x.labelRotate; }, 0),
                    } : undefined,
                }
            };
            return option;
        };
        _this.findDataElement = function (path) {
            return undefined;
        };
        return _this;
    }
    return Tree;
}(DiagramBase));
export default Tree;
//# sourceMappingURL=Tree.js.map